// ---- Platform type, here always web
export const Platform = {
    WEB: 'web',
    MOBILE: 'mobile'
}